export const GRID = "grid";
export const HORIZONTAL_BAR = "horizontal_bar";
export const HTML = "html";
export const MILESTONES = "milestones";
export const NUMBER = "number";
export const PIE = "pie";
export const REMEDIES = "remedies";
export const SANKEY = "sankey";
export const STACKED_BAR = "stacked_bar";
export const STATS = "stats";
export const TABLE = "table";
export const TIMELINES = "timelines";
